import script from "./pause-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./pause-menu.vue?vue&type=script&setup=true&lang=ts"

import "./pause-menu.vue?vue&type=style&index=0&id=2b98350d&lang=scss"

const __exports__ = script;

export default __exports__